export default {
  新增模板: "Add Template",
  供应商类别: "Supplier Category",
  考核维度: "Assessment Dimension",
  考核项: "Assessment Item",
  请完善模板信息: "Please complete the template information",
  保存成功: "Saved successfully",
  更新成功: "Updated successfully",
  需要至少新增一个考核维度: "At least one assessment dimension is required",
  "所有考核项的权重总和不能超过100%，当前为{{totalWeight}}%":
    "The total weight of all assessment items cannot exceed 100%, current is {{totalWeight}}%",
  新增维度: "Add Dimension",
  "优秀 (100分)": "Excellent (100 points)",
  "良好 (75分)": "Good (75 points)",
  "一般 (50分)": "Fair (50 points)",
  "差 (25分)": "Poor (25 points)",
  序号: "No.",
  考核权重: "Weight",
  考核部门: "Department",
  考核等级: "Grade",
  等级描述: "Description",
  操作: "Action",
  必填: "Required",
  输入考核项: "Enter assessment item",
  选择部门: "Select department",
  请输入等级描述: "Enter grade description",
  删除考核项: "Delete Assessment Item",
  "您确定要删除该考核项吗？":
    "Are you sure you want to delete this assessment item?",
  添加: "Add",
  "暂无考核项，请点击下方按钮添加":
    "No assessment items, click the button below to add",
  删除成功: "Deleted successfully",
  确认操作: "Confirm Action",
  "确认删除该类别吗？": "Are you sure you want to delete this category?",
  请输入维度名称: "Enter dimension name",
  删除考核维度: "Delete Assessment Dimension",
  "您确定要删除该考核维度吗？":
    "Are you sure you want to delete this assessment dimension?",
  删除阶段: "Delete",
  考核标准: "Assessment Standard",
  等级: "Grade",
  描述: "Description",
  考核标准权重: "Weight",
  取消: "Cancel",
};
